import React from 'react';
import ReactDOM from 'react-dom';
import {MuiThemeProvider} from '@material-ui/core/styles';
import theme from '../../theme';
import {create} from 'jss';
import {StylesProvider, jssPreset} from '@material-ui/styles';

const jss = create({
    plugins: [...jssPreset().plugins],
});

export type MapboxControlButtonProps =
    React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>;

export function MapboxControlButton({style = {}, ...props}: MapboxControlButtonProps) {
    return <button
        style={{
            paddingTop: 4,
            paddingBottom: 4,
            textAlign: 'center',
            ...style,
        }}
        {...props}
        type={undefined}
    />;
}

export function MapboxControlGroup(props: React.HTMLAttributes<HTMLDivElement>) {
    return <div className='mapboxgl-ctrl mapboxgl-ctrl-group' {...props} />;
}

let nextIndex = 0;

export function createReactMapboxControl<Props>(Component: any) {
    return class {
        props: Props;
        index: number;
        container = document.createElement('div');

        constructor(props: Props) {
            this.props = props;
            this.index = nextIndex++;
        }

        onAdd() {
            this.render();
            return this.container;
        }

        onRemove() {
            ReactDOM.unmountComponentAtNode(this.container);
            if (this.container.parentNode) {
                this.container.parentNode.removeChild(this.container);
            }
        }

        render() {
            ReactDOM.render(<StylesProvider jss={jss}>
                <MuiThemeProvider theme={theme}>
                    <Component {...this.props} />
                </MuiThemeProvider>
            </StylesProvider>, this.container);
        }

        setProps(props: Props) {
            this.props = props;
            this.render();
        }
    };
}
